import type { LeadFormDeliveryContext, LeadFormType } from "./types";

import { LEAD_FORM_CONTRACTS } from "./form-contracts";
import { POSTAL_CODE_FIELD_NAME } from "./lead-form-field-names";

function getRequiredLeadFormFieldNames({
  deliveryContext,
  formType,
}: {
  deliveryContext: LeadFormDeliveryContext;
  formType: LeadFormType;
}): string[] {
  const contract = LEAD_FORM_CONTRACTS[formType];
  const requiredFieldNames: string[] = [...contract.requiredFieldNames];

  if (contract.postalSource[deliveryContext] === "authoredVisibleInput") {
    requiredFieldNames.push(POSTAL_CODE_FIELD_NAME);
  }

  return requiredFieldNames;
}

export { getRequiredLeadFormFieldNames };
